import * as classnames from 'classnames';
import * as React from 'react';

import ReactSelect from 'react-select';

import { FormattedMessage } from 'react-intl';
import { change, touch, WrappedFieldProps } from 'redux-form';

import 'react-select/scss/default.scss';
import './InputSelect.scss';

interface InputSelectOption {
  value: string;
  label: string;
}

export interface InputSelectProps {
  className?: string;
  disabled?: boolean;
  footnote?: string;
  isLoading?: boolean;
  label: string;
  noResultsText?: string;
  options: InputSelectOption[];
}

export class InputSelect extends React.Component<InputSelectProps & WrappedFieldProps, {}> {
  private input: ReactSelect;

  constructor(props: InputSelectProps & WrappedFieldProps) {
    super(props);

    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);
    this.setReference = this.setReference.bind(this);
  }

  focus() {
    return this.input.focus();
  }

  render() {
    const { className, disabled, footnote, input, isLoading, label, meta, noResultsText, options } = this.props;
    const classNameError = meta.touched && meta.error && 'input-select--is-error';
    const classNameFootnoteError = meta.touched && meta.error && 'input-select__footnote--is-error';
    return (
      <div className={classnames('input-select__container', className, classNameError)}>
        <ReactSelect
          clearable={false}
          disabled={disabled || isLoading}
          isLoading={isLoading}
          noResultsText={noResultsText}
          options={options}
          onBlur={this.onBlur}
          onChange={this.onChange}
          placeholder=""
          ref={this.setReference}
          value={input.value}
        />

        <label className="input-select__label">{label}</label>

        <p className="input-select__footnote">
          {meta.touched && meta.error && <span className={classnames(classNameFootnoteError)}><FormattedMessage id={meta.error}/></span>}
          {!classNameFootnoteError && footnote && <span>{footnote}</span>}
        </p>
      </div>
    );
  }

  private onBlur(event: React.FocusEvent<HTMLInputElement>) {
    const { input, meta } = this.props;
    if (!input.value) {
      meta.dispatch(touch(meta.form, ...[input.name]));
    }
  }

  private onChange(option: InputSelectOption) {
    const { input, meta } = this.props;
    meta.dispatch(change(meta.form, input.name, option ? option.value : ''));
  }

  private setReference(reactSelect: ReactSelect) {
    this.input = reactSelect;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Input/InputSelect/InputSelect.tsx